import { Client } from '../client_server.js'
let g_client = new Client('widget_4_parent', window.parent)

export default {
	clear: () => g_client.call('clear_local_storage'),
	get: (key, def_value) => g_client.call('get_local_storage', key, def_value),
	set: (key, value, ttl) => g_client.call('set_local_storage', key, value, ttl),
	remove: key => g_client.call('remove_local_storage', key),
}
